import 'babel-polyfill';

import ReactDOM from 'react-dom';
import router from './router';
import './stylesheets/main.css';

ReactDOM.render(
    router,
    document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/